import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import {
  Check,
  CheckGroup,
  form,
  Form as AppForm,
  FormInput,
  Select,
  TextArea,
  PhoneNumberField
} from "MODULES/shared/components/Forms";
import { DashedSeparator } from "MODULES/shared/components";
import { SALUTATIONS } from "MODULES/companies/constants";
import * as actions from "MODULES/companies/actions";
import validate from "../validate";

export function Form(props) {
  return (
    <div>
      <AppForm {...props}>
        <AppForm.Body>
          <Row className="row-col-gutters-half">
            <Col md={2}>
              <Field
                name="title"
                component={Select}
                label="Salutation"
                options={SALUTATIONS}
              />
            </Col>
            <Col md={4}>
              <Field name="name" component={FormInput} label="Name" required />
            </Col>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="primary" className="control-label">
                  Primary Contact
                </label>
                <br />
                <div
                  className="btn-group full-width-checkbox"
                  data-toggle="buttons"
                >
                  <Field
                    className="physicalAddressPrimary"
                    name="primary"
                    component={Check}
                    label="Yes"
                  />
                </div>
              </div>
            </Col>
            <Col md={3}>
              <CheckGroup justified title="Exchange Manager">
                <Field name="exchange_manager" component={Check} label="Yes" />
              </CheckGroup>
            </Col>
          </Row>
          <DashedSeparator />
          <Row className="row-col-gutters-half">
            <Col md={4}>
              <Field
                name="position"
                component={FormInput}
                label="Position/Title"
              />
            </Col>
            <Col md={5}>
              <Field
                name="email"
                component={FormInput}
                label="Email"
                required
              />
            </Col>
            <Col md={3}>
              <div className="form-group">
                <label htmlFor="promotion_ok" className="control-label">
                  Promotions OK
                </label>
                <br />
                <div
                  className="btn-group full-width-checkbox"
                  data-toggle="buttons"
                >
                  <Field
                    className="physicalAddressPrimary"
                    name="promotion_ok"
                    component={Check}
                    label="Yes"
                  />
                </div>
              </div>
            </Col>
          </Row>
          <DashedSeparator />
          <Row className="row-col-gutters-half">
            <Col md={4}>
              <PhoneNumberField
                name="phone1"
                component={FormInput}
                label="Phone Number 1"
                type="tel"
              />
            </Col>
            <Col md={4}>
              <PhoneNumberField
                name="phone2"
                component={FormInput}
                label="Phone Number 2"
                type="tel"
              />
            </Col>
            <Col md={4}>
              <PhoneNumberField
                name="phone3"
                component={FormInput}
                label="Phone Number 3"
                type="tel"
              />
            </Col>
          </Row>
          <Row className="row-col-gutters-half">
            <Col md={12}>
              <Field name="notes" component={TextArea} label="note" />
            </Col>
          </Row>
        </AppForm.Body>
      </AppForm>
    </div>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.createContact(data))
}))(
  form({
    form: "createCompanyContact",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Contacts/Create/Form.jsx